import { Link } from 'react-router-dom';

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3 md:mb-5">
      <div>
        {eyebrow && (
          <span className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-sm text-foreground-500">{description}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}